module.exports = __webpack_public_path__ + "../resources/images/illustration_archive-b19d3deb005756483d6de50c15c41a51.svg";